:host {
	font-family: monospace;
	display: inline;
	color: rgb(var(--smoothly-default-contrast));
}
:host[hidden] {
	display: none;
}
